import {
  IServiceOrderData,
  IAddOrderResponseData,
  IListResponse,
  IOrderData,
  IOrderHistoryData,
  IRequestExtended,
  ITravelInfoIdsExtendedData,
  IPublicPlanOrderData,
  IRequestTravelHistoryData,
  IPlanOrderData,
  ISolutionOrderData,
  IPromoCodeOrderData, IRequestServiceData, IAppendServiceData, IOrderUpdateStatus
} from '@/entities'
import {
  IRequestService
} from './index'
import {
  AxiosInstance,
  AxiosResponse
} from 'axios'
import {
  defaultConfig
} from '../config'


export class RequestService implements IRequestService {
  constructor(private readonly axios: AxiosInstance) {}

  async addServiceOrder(data: IServiceOrderData, language?: string): Promise<AxiosResponse<IAddOrderResponseData>> {
    return this.axios.post('/order/add_service/', data, defaultConfig(language))
  }

  async addPublicPlanOrder(data: IPublicPlanOrderData, language?: string): Promise<AxiosResponse<IAddOrderResponseData>> {
    return this.axios.post('/order/add_plan/', data, defaultConfig(language))
  }

  async addPlanOrder(data: IPlanOrderData, language?: string): Promise<AxiosResponse<IAddOrderResponseData>> {
    return this.axios.post('/order/add_individual_plan/', data, defaultConfig(language))
  }

  async addSolutionOrder(data: ISolutionOrderData, language?: string): Promise<AxiosResponse<IAddOrderResponseData>> {
    return this.axios.post('/order/add_solution/', data, defaultConfig(language))
  }

  async addPromoCodeOrder(data: IPromoCodeOrderData, language?: string): Promise<AxiosResponse<IAddOrderResponseData>> {
    return this.axios.post('/order/add_promo_code/', data, defaultConfig(language))
  }

  async getOrderByToken(data: IRequestExtended, language?: string): Promise<AxiosResponse<IOrderData | undefined>> {
    return this.axios.get(`/order/${ data.key }/`, {
      ...defaultConfig(language),
      ...data.config
    })
  }

  async addConsultationInfo(data: IRequestExtended<ITravelInfoIdsExtendedData>): Promise<void> {
    return this.axios.post(`/order/${ data.key }/add_consultation_info/`, data.payload)
  }

  async getOrderHistories(data: IRequestExtended): Promise<AxiosResponse<IListResponse<IOrderHistoryData[]>>> {
    return this.axios.get(`/order/${ data.key }/history/`, {
      ...defaultConfig(),
      ...data.config
    })
  }

  async getRequestTravelHistories(data: IRequestExtended): Promise<AxiosResponse<IListResponse<IRequestTravelHistoryData[]>>> {
    return this.axios.get(`/request_travel/${ data.key }/history/`, {
      ...defaultConfig(),
      ...data.config
    })
  }

  async appendService(data: IRequestExtended<IAppendServiceData>, language?: string): Promise<AxiosResponse<IRequestServiceData>> {
    return this.axios.post(`/order/${ data.key }/append_service/`, data.payload, {
      ...defaultConfig(language),
      ...data.config
    })
  }

  async cancelOrder(data: IRequestExtended, language?: string): Promise<AxiosResponse<IOrderUpdateStatus>> {
    return this.axios.post(`/order/${ data.key }/cancel/`, null, {
      ...defaultConfig(language),
      ...data.config
    })
  }

}
